import Component from 'flarum/common/Component';
import AdBanner from './AdBanner';
export default class AdWidget extends Component {
  view() {
    const ads = this.attrs.ads || [];
    if (!ads.length) return null;
    return m("div", {
      className: "AdWidget"
    }, ads.map(ad => m(AdBanner, {
      key: ad.id,
      ad: ad,
      className: "AdBanner--sidebar"
    })));
  }
}
flarum.reg.add('ralkage-ad-management', 'forum/components/AdWidget', AdWidget);